import { Tabs } from 'antd';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import ActivitiesTab from './activitiesTab';
import GeneralTab from './generalATab';

type ContactSegmentDetailProps = {
  contactSegmentationId: string;
};

function ContactSegmentDetail(props: ContactSegmentDetailProps) {
  const { contactSegmentationId } = props;
  const { t } = useTranslation();

  return (
    <div className="p-3 border border-gray-300 border-t-0 rounded-b-sm [&_textarea:forcus]:!shadow-none">
      <Tabs
        type="line"
        size={'small'}
        className="[&_.ant-tabs-ink-bar]:!bg-primary"
        items={[
          {
            label: t('segment.tt-chung'),
            key: '1',
            children: <GeneralTab contactSegmentationId={contactSegmentationId} />,
          },

          {
            label: t('segment.hoat-dong'),
            key: '3',
            children: <ActivitiesTab contactSegmentationId={contactSegmentationId} />,
          },
        ]}
      />
    </div>
  );
}

export default observer(ContactSegmentDetail);
